export default "__VITE_ASSET__B71Oc$3r__";